import type { ReactNode } from "react";

export function TabButton({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`-mb-px px-2 pb-3 pt-2 border-b-2 uppercase tracking-wide text-sm font-bold transition-colors ${
        active
          ? "text-white border-white"
          : "text-white/40 border-transparent hover:text-white/70"
      }`}
    >
      {children}
    </button>
  );
}
